"use client";
import React from "react";
import PropTypes from "prop-types";
import BtnMeContacter from "../../components/BtnMeContacter.js";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faSearch } from "@fortawesome/free-solid-svg-icons";
import Breadcrumbs from "../../components/Breadcrumbs.jsx";

export default function ServicesPage() {
  return (
    <div>
      <main id="main" className="mx-10 px-4 my-10">
        <Breadcrumbs currentPage="Services Web" />

        <h1 className="text-4xl my-10 flex items-center">
          <FontAwesomeIcon icon={faGlobe} className="w-12 h-12 p-2 mr-2" />
          Services de développement web freelance
        </h1>

        <p className="text-lg text-gray-600">
          J’accompagne les entreprises, artisans et indépendants dans la
          création, l’évolution et la visibilité de leur site internet, avec une
          approche fiable, durable et orientée résultats.
        </p>

        {/* SERVICE 1 */}
        <section className="px-6 mx-auto max-w-5xl my-10">
          <ServiceBlock
            title="Création & refonte de site internet"
            subtitle="Un site moderne, rapide et pensé pour vos objectifs"
            content={[
              "Création de site vitrine professionnel",
              "Refonte de site existant (design, performance, SEO)",
              "Site responsive (mobile, tablette, desktop)",
              "Code propre, maintenable et évolutif",
              "Optimisation des performances et de l’accessibilité",
            ]}
            cta="Demander un devis pour mon site"
            href="/contact"
            ImgAlt="Création & refonte de site internet - Développeur freelance"
            ImgSrc="/creation-refonte-site-web.png"
          />
        </section>

        {/* SERVICE 2 */}
        <section className="bg-gray-50 py-10 px-6 my-10">
          <div className="max-w-5xl mx-auto">
            <ServiceBlock
              title="Maintenance & suivi technique"
              subtitle="Un site sécurisé et fonctionnel dans la durée"
              content={[
                "Mises à jour techniques et correctifs",
                "Surveillance de la sécurité et des performances",
                "Sauvegardes régulières",
                "Corrections de bugs et évolutions mineures",
                "Assistance technique et conseils",
              ]}
              cta="Mettre en place une maintenance"
              href="/contact"
              ImgAlt="Maintenance & suivi technique - Développeur freelance"
              ImgSrc="/maintenance-web.jpg"
            />
          </div>
        </section>

        {/* SERVICE 3 */}
        <section className="px-6 mx-auto max-w-5xl my-10">
          <ServiceBlock
            title="Référencement naturel (SEO)"
            subtitle="Gagner en visibilité sur Google durablement"
            content={[
              "Audit SEO technique et sémantique",
              "Optimisation du contenu et des performances",
              "Structure SEO-friendly (balises, maillage, pages)",
              "SEO technique (SSR, Core Web Vitals)",
              "Suivi et recommandations d’amélioration",
            ]}
            cta="Améliorer mon référencement"
            href="/contact"
            ImgAlt="Référencement naturel SEO - Développeur freelance"
            ImgSrc="/referencement-progression.jpg"
          />
        </section>
      </main>
      {/* CTA FINAL */}
      <section className="py-24 px-6 text-center bg-gray-100">
        <h2 className="text-3xl font-bold mb-6">Un projet ? Une question ?</h2>
        <p className="text-gray-600 mb-8">
          Création de site, maintenance ou référencement naturel.
        </p>
        <BtnMeContacter />
      </section>
    </div>
  );
}

function ServiceBlock({ title, subtitle, content, cta, href, ImgSrc, ImgAlt }) {
  return (
    <div className="flex flex-col md:flex-row">
      <div className="mr-10 mb-10">
        <img
          src={ImgSrc}
          alt={ImgAlt}
          className="md:max-w-48"
          width={200}
          height={200}
        />
      </div>
      <div className="flex flex-col gap-8">
        <div>
          <h2 className="text-3xl font-bold mb-3">{title}</h2>
          <p className="text-gray-600">{subtitle}</p>
        </div>

        <ul className="grid md:grid-cols-2 gap-4 text-gray-700">
          {content.map((item, index) => (
            <li key={index}>✔ {item}</li>
          ))}
        </ul>

        <div>
          <motion.a
            whileHover="hover"
            href={href}
            className="inline-flex items-center px-4 py-2 bg-bleuciel text-white rounded-full hover:bg-blue transition duration-300 mx-2"
            aria-label={cta}
            title={cta}>
            <motion.div
              className="mr-2"
              variants={{
                rest: { rotate: 0 },
                hover: {
                  rotate: 360,
                  transition: { duration: 0.6 },
                },
              }}>
              <FontAwesomeIcon icon={faSearch} />
            </motion.div>
            {cta}
          </motion.a>
        </div>
      </div>
    </div>
  );
}
ServiceBlock.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(PropTypes.string).isRequired,
  cta: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  ImgSrc: PropTypes.string.isRequired,
  ImgAlt: PropTypes.string.isRequired,
};
